/* Noser Groessentabellen - Daten (aus data/products.js, 1:1 uebernommen) */
(function(){
// Noser Fashion – Grössentabellen-Daten (DE/EN)
// Quelle: Original-PDFs (uploads/), Stand Juli 2026

const ui = {
  eyebrow: { de: 'Grössentabelle', en: 'Size Chart' },
  measurements: { de: 'Masse', en: 'Measurements' },
  allCm: { de: 'Alle Masse in cm', en: 'All measurements in cm' },
  size: { de: 'Grösse', en: 'Size' },
    sketch: { de: 'Schnittzeichnung', en: 'Cut illustration' },
  material: { de: 'Material', en: 'Material' },
  care: { de: 'Pflegehinweise', en: 'Care instructions' },
  fit: { de: 'Schnitt', en: 'Fit' },
  madeInEU: { de: 'Made in EU', en: 'Made in EU' },
  howto: { de: 'So misst du richtig', en: 'How to measure' },
  advisorTitle: { de: 'Grössenberater', en: 'Size finder' },
  advisorHint: { de: 'Gib dein Mass ein und wir empfehlen dir die passende Grösse.', en: 'Enter your measurement and we will recommend the right size.' },
  advisorResult: { de: 'Deine empfohlene Grösse', en: 'Your recommended size' },
  advisorNone: { de: 'Dein Mass liegt ausserhalb unseres Grössenbereichs.', en: 'Your measurement is outside our size range.' },
  advisorPlaceholder: { de: 'z.B. 96', en: 'e.g. 96' },
  cm: { de: 'cm', en: 'cm' },
  selectHint: { de: 'Grösse antippen, um die Spalte hervorzuheben', en: 'Tap a size to highlight its column' },
  step: { de: 'Sustainable Textile Production (STeP) by OEKO-TEX®', en: 'Sustainable Textile Production (STeP) by OEKO-TEX®' },
  inseam: { de: 'Innenbeinlänge', en: 'Inseam length' },
  shrink: { de: '1–2% Schrumpf.', en: '1–2% shrinkage.' },
};

const hinweisStandard = {
  de: 'Diese Grössentabelle dient zur Hilfestellung deiner Grössenauswahl. Wenn sich eine deiner Messungen an der Grenze zwischen zwei Grössen befindet, kannst du die kleinere Grösse für eine engere Passform oder die grössere Grösse für eine lockere Passform wählen. Wenn deine Oberweite und Taillenweite zwei verschiedenen empfohlenen Grössen entsprechen, solltest du die bestellen, die durch die Messung deiner Oberweite angezeigt wird.',
  en: 'This size chart is a guide to help you choose your size. If one of your measurements falls on the border between two sizes, choose the smaller size for a closer fit or the larger size for a looser fit. If your chest and waist measurements correspond to two different recommended sizes, order the size indicated by your chest measurement.',
};

const hinweisHose = {
  de: 'Liegt dein Mass zwischen zwei Grössen, wähle die grössere Grösse für eine optimale Passform. 1–2% Schrumpf.',
  en: 'If your measurement falls between two sizes, choose the larger size for an optimal fit. 1–2% shrinkage.',
};

const euText = {
  de: 'Der Stoff wird exklusiv in der EU entwickelt und hergestellt. Aspekte wie Nachhaltigkeit, Fairness, Transparenz und Zuverlässigkeit sind garantiert.',
  en: 'The fabric is developed and produced exclusively in the EU. Aspects such as sustainability, fairness, transparency and reliability are guaranteed.',
};

const L = {
  oberweite: { de: 'Oberweite', en: 'Chest width' },
  taillenweite: { de: 'Taillenweite', en: 'Waist width' },
  hueftweite: { de: 'Hüftweite', en: 'Hip width' },
  aermellaenge: { de: 'Ärmellänge', en: 'Sleeve length' },
  rueckenlaenge: { de: 'Rückenlänge', en: 'Back length' },
  kragenweite: { de: 'Kragenweite', en: 'Collar width' },
  rueckenbreite: { de: 'Rückenbreite', en: 'Back width' },
};

const matPace = { de: '73% Polyamid | 18% Polyester | 9% Elastan', en: '73% polyamide | 18% polyester | 9% elastane' };
const matScore = { de: '14% Bio-Baumwolle | 81% Recycled Polyester (drirelease™) | 5% Elastan', en: '14% organic cotton | 81% recycled polyester (drirelease™) | 5% elastane' };
const matPolo = { de: '55% Bio-Baumwolle | 45% Recycled Polyester (Seaqual™)', en: '55% organic cotton | 45% recycled polyester (Seaqual™)' };
const matOvershirt = { de: '64% Polyester | 34% Viskose | 2% Elastan', en: '64% polyester | 34% viscose | 2% elastane' };

const messBund = {
  title: { de: 'Bundweite (W)', en: 'Waist width (W)' },
  text: {
    de: 'Messe beim Hosenbund von der einen zur anderen Seite. Schliesse dabei den obersten Knopf und halte den Bund etwas in Spannung. Deine gemessene Grösse kannst du nun verdoppeln. So erhältst du deine korrekte Bundweite in cm.',
    en: 'Measure across the waistband from one side to the other with the top button closed, keeping the waistband slightly taut. Double the measured value to get your correct waist width in cm.',
  },
};
const messSchritt = {
  title: { de: 'Schrittlänge (L)', en: 'Inseam length (L)' },
  text: {
    de: 'Lege deine Hose flach hin. Nimm ein Hosenbein und miss auf der Innenseite vom Schritt bis zum Ende des Hosenbeins. So erhältst du deine korrekte Schrittlänge in cm. Beachte, dass bei unserer Evolution Chino die Schrittlänge per Druckknopfsystem um 3 cm und 7 cm verkürzt werden kann.',
    en: 'Lay your trousers down flat. Take one leg and measure along the inside from the crotch to the end of the leg. This gives you your correct inseam length in cm. Note that the inseam of our Evolution Chino can be shortened by 3 cm or 7 cm using the snap-fastener system.',
  },
};
const careHose = {
  de: 'Mit gleichen Farben waschen empfohlen. Die Noser Evolution Hose ist bei Haushalts- und Industriewäsche sehr leicht zu pflegen und benötigt nahezu kein Bügeln.',
  en: 'Washing with similar colours is recommended. The Noser Evolution trousers are very easy to care for in household and industrial laundry and require almost no ironing.',
};
const careShorts = {
  de: 'Mit gleichen Farben waschen empfohlen. Die Noser Evolution Shorts ist bei Haushalts- und Industriewäsche sehr leicht zu pflegen und benötigt nahezu kein Bügeln.',
  en: 'Washing with similar colours is recommended. The Noser Evolution shorts are very easy to care for in household and industrial laundry and require almost no ironing.',
};

function top(id, titleDe, titleEn, date, img, material, sizes, rows, note) {
  return {
    id, type: 'top',
    title: { de: titleDe, en: titleEn },
    date, image: 'size-chart-' + img + '.png',
    material, note: note || null,
    hinweis: hinweisStandard, eu: euText,
    sizes, rows,
    advisor: { label: L.oberweite, rowIndex: 0 },
  };
}

const products = {
  'tshirt-damen': top('tshirt-damen', 'Score T-Shirt Damen', 'Score T-Shirt Women', { de: 'August 2025', en: 'August 2025' }, 'tshirt-damen', matScore,
    ['XXS','XS','S','M','L','XL','XXL'],
    [ { k:'A', label:L.oberweite, v:[82,88,94,100,106,112,118] },
      { k:'B', label:L.taillenweite, v:[67,73,79,85,91,97,103] },
      { k:'C', label:L.aermellaenge, v:[17.5,18,18.5,19,19.5,20,20.5] },
      { k:'D', label:L.rueckenlaenge, v:[57,59,61,62,63,64,65.5] } ]),
  'tshirt-herren': top('tshirt-herren', 'Score T-Shirt Herren', 'Score T-Shirt Men', { de: 'August 2025', en: 'August 2025' }, 'tshirt-herren', matScore,
    ['XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[95,101,107,113,121,129,137] },
      { k:'B', label:L.taillenweite, v:[89,95,101,107,115,123,131] },
      { k:'C', label:L.aermellaenge, v:[22,22.5,23,23.5,24,24.5,25] },
      { k:'D', label:L.rueckenlaenge, v:[66,68,70,71,73,75,77] } ]),
  'polo-damen': top('polo-damen', 'Performance Poloshirt Damen', 'Performance Polo Shirt Women', { de: 'Mai 2025', en: 'May 2025' }, 'polo-damen', matPolo,
    ['XXS','XS','S','M','L','XL','XXL'],
    [ { k:'A', label:L.oberweite, v:[82,86,92,98,104,110,116] },
      { k:'B', label:L.taillenweite, v:[70,76,82,88,94,100,106] },
      { k:'C', label:L.aermellaenge, v:[17.5,18,18.5,19,19.5,20,20.5] },
      { k:'D', label:L.rueckenlaenge, v:[60,62,64,65,66,67,68.5] } ]),
  'polo-herren': top('polo-herren', 'Performance Poloshirt Herren', 'Performance Polo Shirt Men', { de: 'Mai 2025', en: 'May 2025' }, 'polo-herren', matPolo,
    ['XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[94,100,106,112,120,128,136] },
      { k:'B', label:L.taillenweite, v:[88,94,100,106,114,122,130] },
      { k:'C', label:L.aermellaenge, v:[24,24.5,25,25.5,26,26.5,27] },
      { k:'D', label:L.rueckenlaenge, v:[68,70,72,74,76,78,80] } ]),
  'overshirt-damen': top('overshirt-damen', 'Drift Overshirt Damen', 'Drift Overshirt Women', { de: 'Oktober 2025', en: 'October 2025' }, 'overshirt-damen', matOvershirt,
    ['XXS','XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[92,98,104,110,116,122,128,134] },
      { k:'B', label:L.hueftweite, v:[90,96,102,108,114,120,126,132] },
      { k:'C', label:L.aermellaenge, v:[62,62,62,63,64,65,66,67] },
      { k:'D', label:L.rueckenlaenge, v:[67,69,70,71,73,74,75,76] } ]),
  'overshirt-herren': top('overshirt-herren', 'Drift Overshirt Herren', 'Drift Overshirt Men', { de: 'Oktober 2025', en: 'October 2025' }, 'overshirt-herren', matOvershirt,
    ['XXS','XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[92,98,104,110,116,122,128,134] },
      { k:'B', label:L.hueftweite, v:[90,96,102,108,114,120,126,132] },
      { k:'C', label:L.aermellaenge, v:[62,62,62,63,64,65,66,67] },
      { k:'D', label:L.rueckenlaenge, v:[67,69,70,71,73,74,75,76] } ]),
  'hoodie-damen': top('hoodie-damen', 'Pace Hoodie Damen', 'Pace Hoodie Women', { de: 'Februar 2026', en: 'February 2026' }, 'hoodie-damen', matPace,
    ['XXS','XS','S','M','L','XL','XXL'],
    [ { k:'A', label:L.oberweite, v:[82,88,94,100,106,112,118] },
      { k:'B', label:L.hueftweite, v:[80,86,92,98,104,110,116] },
      { k:'C', label:L.aermellaenge, v:[63,63,63,64,65,66,67] },
      { k:'D', label:L.rueckenlaenge, v:[64,64,65,67,67,69,71] } ]),
  'hoodie-herren': top('hoodie-herren', 'Pace Hoodie Herren', 'Pace Hoodie Men', { de: 'Februar 2026', en: 'February 2026' }, 'hoodie-herren', matPace,
    ['XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[100,106,112,118,124,130,136] },
      { k:'B', label:L.hueftweite, v:[90,96,102,108,114,120,126] },
      { k:'C', label:L.aermellaenge, v:[63,63,64,65,66,67,67] },
      { k:'D', label:L.rueckenlaenge, v:[68,68,70,72,74,75,76] } ]),
  'quarterzip-damen': top('quarterzip-damen', 'Pace Quarter Zip Pullover Damen', 'Pace Quarter Zip Pullover Women', { de: 'Februar 2026', en: 'February 2026' }, 'quarterzip-damen', matPace,
    ['XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[100,106,112,118,124,130,136] },
      { k:'B', label:L.hueftweite, v:[90,96,102,108,114,120,126] },
      { k:'C', label:L.aermellaenge, v:[63,63,64,65,66,67,67] },
      { k:'D', label:L.rueckenlaenge, v:[68,68,70,72,74,75,76] } ],
    { de: 'Hinweis: Unsere Quarter Zip Pullover sind Unisex-Artikel und fallen bei Damen eher gross aus. Wir empfehlen, gegebenenfalls eine Grösse kleiner zu wählen.',
      en: 'Note: Our quarter zip pullovers are unisex articles and tend to run large for women. If in doubt, we recommend choosing one size smaller.' }),
  'quarterzip-herren': top('quarterzip-herren', 'Pace Quarter Zip Pullover Herren', 'Pace Quarter Zip Pullover Men', { de: 'Februar 2026', en: 'February 2026' }, 'quarterzip-herren', matPace,
    ['XS','S','M','L','XL','XXL','3XL'],
    [ { k:'A', label:L.oberweite, v:[100,106,112,118,124,130,136] },
      { k:'B', label:L.hueftweite, v:[90,96,102,108,114,120,126] },
      { k:'C', label:L.aermellaenge, v:[63,63,64,65,66,67,67] },
      { k:'D', label:L.rueckenlaenge, v:[68,68,70,72,74,75,76] } ]),
  'bluse': (() => {
    const p = top('bluse', 'Performance Bluse Damen', 'Performance Blouse Women', { de: 'April 2025', en: 'April 2025' }, 'bluse', null,
      ['XXS','XS','S','M','L','XL','XXL','3XL'],
      [ { k:'A', label:L.kragenweite, v:[32,34,36,38,40,42,44,46] },
        { k:'B', label:L.rueckenbreite, v:[34,35,36,37,38,39,40.5,42] },
        { k:'C', label:L.oberweite, v:[88,92,96,100,104,108,114,120] },
        { k:'D', label:L.taillenweite, v:[78,82,86,90,94,98,104,110] },
        { k:'E', label:L.aermellaenge, v:[62,62,62,62,62,62,62,62] },
        { k:'F', label:L.rueckenlaenge, v:[65,65,65,65,65,68,68,68] },
        { k:'G', label:L.hueftweite, v:[89,93,97,101,105,109,119,125] } ]);
    p.advisor = { label: L.oberweite, rowIndex: 2 };
    p.madeInEU = true;
    p.sketch = 'size-chart-bluse-schnitt.png';
    return p;
  })(),
  'hemden': {
    id: 'hemden', type: 'shirts',
    title: { de: 'Performance Hemd Herren', en: 'Performance Shirt Men' },
    date: { de: 'November 2024', en: 'November 2024' },
    image: 'size-chart-hemden.png',
    material: null, note: null, hinweis: hinweisStandard, eu: euText, madeInEU: true,
    fits: [
      { label: { de: 'Slim Fit', en: 'Slim Fit' }, sketch: 'size-chart-hemd-schnitt-slim.png', sizes: ['XS','S','M','L','XL','XXL'],
        rows: [ { k:'A', label:L.kragenweite, v:[37,38,40,42,44,46] },
                { k:'B', label:L.rueckenbreite, v:[40,41.5,43,44.5,46,48] },
                { k:'C', label:L.oberweite, v:[96,102,108,114,124,134] },
                { k:'D', label:L.taillenweite, v:[82,90,98,104,114,124] },
                { k:'E', label:L.aermellaenge, v:[63,64,65,65,65,65] },
                { k:'F', label:L.rueckenlaenge, v:[75,75,77,77,80,82] } ] },
      { label: { de: 'Modern Fit', en: 'Modern Fit' }, sketch: 'size-chart-hemd-schnitt-modern.png', sizes: ['S','M','L','XL','XXL'],
        rows: [ { k:'A', label:L.kragenweite, v:[38,40,42,44,46] },
                { k:'B', label:L.rueckenbreite, v:[43,45,47,49,51] },
                { k:'C', label:L.oberweite, v:[108,114,120,128,138] },
                { k:'D', label:L.taillenweite, v:[98,106,114,124,134] },
                { k:'E', label:L.aermellaenge, v:[64,65,65,65,65] },
                { k:'F', label:L.rueckenlaenge, v:[77,78,79,80,82] } ] },
      { label: { de: 'Regular Fit', en: 'Regular Fit' }, sketch: 'size-chart-hemd-schnitt-regular.png', sizes: ['L','XL','XXL','3XL'],
        rows: [ { k:'A', label:L.kragenweite, v:[42,44,46,48] },
                { k:'B', label:L.rueckenbreite, v:[49,51,53,55] },
                { k:'C', label:L.oberweite, v:[124,132,144,154] },
                { k:'D', label:L.taillenweite, v:[118,130,142,154] },
                { k:'E', label:L.aermellaenge, v:[65,65,65,65] },
                { k:'F', label:L.rueckenlaenge, v:[82,84,90,90] } ] },
    ],
    advisor: { label: L.oberweite, rowIndex: 2 },
  },
  'hose-herren': {
    id: 'hose-herren', type: 'pants',
    title: { de: 'Evolution Hose Herren', en: 'Evolution Trousers Men' },
    fit: { de: 'Slim Fit', en: 'Slim Fit' },
    date: { de: 'Dezember 2025', en: 'December 2025' },
    hinweis: hinweisHose, care: careHose,
    wSizes: [26,28,30,32,34,36,38,40,42,44],
    konf: [42,44,46,48,50,52,54,56,58,60],
    bundCm: [74,79,84,89,96,99,103,109,114,119],
    inseam: [ { l: '30', cm: '75 cm' }, { l: '32', cm: '79 cm' }, { l: '34', cm: '84 cm' }, { l: '36', cm: '89 cm' } ],
    measures: [
      { img: 'size-chart-hose-bundweite.png', ...messBund },
      { img: 'size-chart-hose-schrittlaenge.png', ...messSchritt },
    ],
    advisor: { type: 'bund' },
  },
  'hose-damen': {
    id: 'hose-damen', type: 'pants',
    title: { de: 'Evolution Hose Damen', en: 'Evolution Trousers Women' },
    fit: { de: 'Slim Fit', en: 'Slim Fit' },
    date: { de: 'Juli 2026', en: 'July 2026' },
    hinweis: hinweisHose, care: careHose,
    wSizes: [26,28,30,32,34,36,38,40,42,44],
    konf: [34,36,38,40,42,44,46,48,50,52],
    bundCm: [74,79,84,89,96,99,103,109,114,119],
    inseam: [ { l: '30', cm: '75 cm' }, { l: '32', cm: '79 cm' }, { l: '34', cm: '84 cm' }, { l: '36', cm: '89 cm' } ],
    measures: [
      { img: 'size-chart-hose-bundweite.png', ...messBund },
      { img: 'size-chart-hose-schrittlaenge.png', ...messSchritt },
    ],
    advisor: { type: 'bund' },
  },
  'shorts': {
    id: 'shorts', type: 'pants',
    title: { de: 'Evolution Shorts', en: 'Evolution Shorts' },
    fit: { de: 'Regular Fit', en: 'Regular Fit' },
    date: { de: 'April 2025', en: 'April 2025' },
    hinweis: hinweisHose, care: careShorts,
    wSizes: [28,30,32,34,36,38,40,42,44],
    konf: [44,46,48,50,52,54,56,58,60],
    bundCm: [79,84,89,96,99,103,109,114,119],
    inseamFixed: { de: 'Innenbeinlänge 27 cm', en: 'Inseam length 27 cm' },
    measures: [ { img: 'size-chart-shorts-bundweite.png', ...messBund } ],
    advisor: { type: 'bund' },
  },
};

const pantsLabels = {
  w: { de: 'Bundweite (W)', en: 'Waist width (W)' },
  konf: { de: 'Konf. Grösse', en: 'Confection size' },
  cm: { de: 'Bundweite in cm', en: 'Waist width in cm' },
  schritt: { de: 'Schrittlänge (L)', en: 'Inseam (L)' },
};

window.NoserSizeChartData = { ui: ui, products: products, pantsLabels: pantsLabels };
})();
